module.exports = __webpack_public_path__ + "0c44371cb0a9aa4de3e8d7a244169b6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/accommodation-with-color.svg
// module id = 1532
// module chunks = 1 6